import React, { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react';
type CountdownValue = {
  hours: string;
  minutes: string;
  seconds: string;
  isExpired: boolean;
};
const CountdownContext = createContext<CountdownValue>({
  hours: '00',
  minutes: '15',
  seconds: '00',
  isExpired: false
});
const START_SECONDS = 15 * 60;
const pad = (n: number) => String(n).padStart(2, '0');
type Props = {
  children: React.ReactNode;
};
export function CountdownProvider({
  children
}: Props) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  const remainingRef = useRef(remaining);
  remainingRef.current = remaining;
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const value = useMemo<CountdownValue>(() => {
    const safe = Math.max(remaining, 0);
    return {
      hours: pad(Math.floor(safe / 3600)),
      minutes: pad(Math.floor(safe % 3600 / 60)),
      seconds: pad(safe % 60),
      isExpired: safe === 0
    };
  }, [remaining]);
  return <CountdownContext.Provider value={value} data-id="element-194" data-mp="3k5ufitplq6ci">
      {children}
    </CountdownContext.Provider>;
}
export function useCountdown() {
  return useContext(CountdownContext);
}